import React from "react";
import { tryGetFile, getUrlFilename } from "@sanity/asset-utils";
import { cn } from "../lib/helpers";
import { Link } from "gatsby";
import Icon from "./icon";
import clientConfig from "../../client-config";

export const Button = ({ node, portableTextButton }) => {
  if (!(node && node.url) && !(node && node.document && node.document.asset)) {
    return null;
  }

  const { asset } =
    tryGetFile(node?.document?.asset?._ref, clientConfig.sanity) || "";

  return (
    <div className={`${portableTextButton ? "" : "pt-btn"} `}>
      {asset && asset.url ? (
        <a
          href={asset.url}
          className={cn("btn", node.secondaryButton && "secondary", portableTextButton && 'portableTextButton')}
          target="_blank"
          rel="noreferrer"
        >
          {node.text}
          <Icon symbol="arrow-right" />
        </a>
      ) : (
        <>
          {node.blank ? (
            <a
              href={node.url}
              className={cn("btn", node.secondaryButton && "secondary", portableTextButton && 'portableTextButton')}
              target="_blank"
              rel="noreferrer"
            >
              {node.text}
              <Icon symbol="arrow-right" />
            </a>
          ) : (
            <Link
              to={node.url}
              className={cn("btn", node.secondaryButton && "secondary", portableTextButton && 'portableTextButton')}
            >
              {node.text}
              <Icon symbol="arrow-right" />
            </Link>
          )}
        </>
      )}
    </div>
  );
};
